import { render, staticRenderFns } from "./FormContactNew.vue?vue&type=template&id=9fa2df5a&"
import script from "./FormContactNew.vue?vue&type=script&lang=js&"
export * from "./FormContactNew.vue?vue&type=script&lang=js&"
import style0 from "./FormContactNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports